<template>
    <div>
        <el-form class="SystemForm" ref="form" :model="form" label-width="150px">
            <el-form-item label="公司名称：" style="width: 400px">
                <el-input v-model="form.company" style="width: 100%"></el-input>
            </el-form-item>

            <el-form-item label="注册日期：" style="width: 400px">
                <el-date-picker type="date" disabled v-model="form.sign_date" placeholder="选择日期" style="width: 100%"> </el-date-picker>
            </el-form-item>
            <el-form-item label="到期日期：" style="width: 400px">
                <el-date-picker type="date" disabled v-model="form.end_date" placeholder="选择日期" style="width: 100%"> </el-date-picker>
            </el-form-item>
            <el-form-item label="默认币别：" style="width: 400px">
                <el-select
                    v-model="form.currency_no"
                    filterable
                    :filter-method="searchCurr"
                    @change="refreshs()"
                    placeholder="请选择"
                    style="width: 100%"
                >
                    <el-option v-for="(item, index) in pull_currency" :key="index" :label="item.kind_name" :value="item.kind_no.toString()">
                        <span style="margin-left: 10px">{{ item.kind_name }}</span>
                        <span style="float: left; color: #8492a6; font-size: 13px">{{ item.kind_no }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="最低库存数量：" style="width: 400px">
                <el-input v-model="form.lowerstock_qty"></el-input>
            </el-form-item>
            <el-form-item label="最低库存重量：" style="width: 400px">
                <el-input v-model="form.lowerstock_wgt"></el-input>
            </el-form-item>
            <el-form-item label="最高库存数量：" style="width: 400px">
                <el-input v-model="form.highstock_qty"></el-input>
            </el-form-item>
            <el-form-item label="最高库存重量：" style="width: 400px">
                <el-input v-model="form.highstock_wgt"></el-input>
            </el-form-item>
            <el-form-item label="金价取值：">
                <el-radio-group v-model="form.gold_price">
                    <el-radio label="1">自定义</el-radio>
                    <el-radio label="2">最新金价</el-radio>
                    <el-radio label="3">当天金价</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="单据金额抹零：">
                <el-radio-group v-model="form.zero_deal">
                    <el-radio label="0">不处理</el-radio>
                    <el-radio label="1">抹掉零头"分"</el-radio>
                    <el-radio label="2">抹掉零头"角"</el-radio>
                    <el-radio label="3">四舍五入到"角"</el-radio>
                    <el-radio label="4">四舍五入到"元"</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="打印金额抹零：">
                <el-radio-group v-model="form.print_zero_deal">
                    <el-radio label="0">不处理</el-radio>
                    <el-radio label="1">抹掉零头"分"</el-radio>
                    <el-radio label="2">抹掉零头"角"</el-radio>
                    <el-radio label="3">四舍五入到"角"</el-radio>
                    <el-radio label="4">四舍五入到"元"</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="日志有效期：">
                <el-radio-group v-model="form.log_date">
                    <el-radio label="7">7天</el-radio>
                    <el-radio label="15">15天</el-radio>
                    <el-radio label="30">30天</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="数量小数位：">
                <el-radio-group v-model="form.qty">
                    <el-radio label="0">0</el-radio>
                    <el-radio label="1">1</el-radio>
                    <el-radio label="2">2</el-radio>
                    <el-radio label="3">3</el-radio>
                    <el-radio label="4">4</el-radio>
                    <el-radio label="5">5</el-radio>
                    <el-radio label="6">6</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="重量小数位：">
                <el-radio-group v-model="form.wgt">
                    <el-radio label="0">0</el-radio>
                    <el-radio label="1">1</el-radio>
                    <el-radio label="2">2</el-radio>
                    <el-radio label="3">3</el-radio>
                    <el-radio label="4">4</el-radio>
                    <el-radio label="5">5</el-radio>
                    <el-radio label="6">6</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="单价小数位：">
                <el-radio-group v-model="form.prc">
                    <el-radio label="0">0</el-radio>
                    <el-radio label="1">1</el-radio>
                    <el-radio label="2">2</el-radio>
                    <el-radio label="3">3</el-radio>
                    <el-radio label="4">4</el-radio>
                    <el-radio label="5">5</el-radio>
                    <el-radio label="6">6</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="金额小数位：">
                <el-radio-group v-model="form.amt">
                    <el-radio label="0">0</el-radio>
                    <el-radio label="1">1</el-radio>
                    <el-radio label="2">2</el-radio>
                    <el-radio label="3">3</el-radio>
                    <el-radio label="4">4</el-radio>
                    <el-radio label="5">5</el-radio>
                    <el-radio label="6">6</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="成色/税率 小数位：">
                <el-radio-group v-model="form.rate">
                    <el-radio label="0">0</el-radio>
                    <el-radio label="1">1</el-radio>
                    <el-radio label="2">2</el-radio>
                    <el-radio label="3">3</el-radio>
                    <el-radio label="4">4</el-radio>
                    <el-radio label="5">5</el-radio>
                    <el-radio label="6">6</el-radio>
                </el-radio-group>
            </el-form-item>
<!--            <el-form-item label="折足重小数处理：">-->
<!--                <el-radio-group v-model="form.transWgtRoundingMode">-->
<!--                    <el-radio label="0">四舍五入</el-radio>-->
<!--                    <el-radio label="1">直接舍去</el-radio>-->
<!--                </el-radio-group>-->
<!--            </el-form-item>-->

            <div class="save">
                <el-button
                    style="display: block; margin-top: 10px"
                    v-if="perData.allow_edit == 1"
                    v-preventReClick
                    type="primary"
                    @click="saveIt()"
                    >{{ $t('common.save') }}</el-button
                >
            </div>
        </el-form>
    </div>
</template>

<script>
import { apiSystem, apiSystemSave, apiSystemPull, apiCurrentPermisson } from '@/request/api';
export default {
    data() {
        return {
            allArr: '',
            form: {},
            pull_currency: [],
            pull_server: [],
            perData: '',
            ms_username: localStorage.getItem('ms_username') || ''
        };
    },
    created() {
        this.geData();
        this.getStoneData();
        this.getPermission();
    },
    methods: {
        // 获取页面信息-----------------------------------------
        geData() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data;
                } else {
                    if (res.data.info == '无数据请先添加' || res.data.info == '没有这条数据') {
                        this.form = {};
                    }
                    this.$message.error(res.data.info);
                }
            });
        },
        // 获取下拉框信息---------------------------------------
        getStoneData() {
            apiSystemPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.pull_currency = res.data.currency;
                    this.pull_server = res.data.server;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '51'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 自定义下拉框筛选
        searchCurr(val) {
            this.form.currency_no = val;
            if (val) {
                var len = this.allArr.currency;
                var arr = [];
                for (var i = 0; i < len.length; i++) {
                    if (len[i].kind_no.toLowerCase().indexOf(val.toLowerCase()) >= 0 || len[i].kind_name.indexOf(val) >= 0) {
                        arr.push(len[i]);
                    }
                }
                this.pull_currency = arr;
            } else {
                this.pull_currency = this.allArr.currency;
            }
        },
        searchServer(val) {
            this.form.server = val;
            if (val) {
                var len = this.allArr.server;
                var arr = [];
                for (var i = 0; i < len.length; i++) {
                    if (len[i].kind_no.toLowerCase().indexOf(val.toLowerCase()) >= 0 || len[i].kind_name.indexOf(val) >= 0) {
                        arr.push(len[i]);
                    }
                }
                this.pull_server = arr;
            } else {
                this.pull_server = this.allArr.server;
            }
        },
        refreshs() {
            this.$forceUpdate();
        },
        //保存
        saveIt() {
            this.$confirm('保存后系统将自动刷新，是否继续？', '提示', {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            }).then(() => {
                let data = this.form;
                apiSystemSave(data).then((res) => {
                    if (res.code == 2000) {
                        this.$message.success('修改成功');
                        this.form = res.data;
                        let validatorData = JSON.stringify(res.data);
                        localStorage.setItem('systemSet', JSON.stringify(res.data));
                        sessionStorage.setItem('validatorData', validatorData);

                        // 显示加载动画并禁用页面交互
                        const loading = this.$loading({
                            lock: true,
                            text: '系统刷新中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });

                        // 保存成功后刷新页面
                        setTimeout(() => {
                            loading.close();
                            location.reload();
                        }, 1500);
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消保存'
                });
            });
        }
    }
};
</script>

<style scoped lang="scss">
.SystemForm {
    background: #fff;
    padding: 20px;
    border-radius: 10px;
}
.SystemForm .el-select {
    width: 100%;
}
/deep/ .el-form-item {
    width: 800px;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
    // width: 300px;
}
.save {
    width: 100%;
    border-top: 1px solid #e7e7e7;
}
</style>
